<template>
	<div style="min-height: 100%; width: 100%; margin-bottom: 75px;" v-if="Object.keys(location).length>0">
		<div class="event-page-header">
			<lory class="event-page-carousel" :options="{ slideSpeed: 150, enableMouseEvents: true, infinite: 1, interval: 10000 }">
				<item class="carousel-image" v-for="(item, index) in getImages" :key="index" style="width: 100%;">
					<div :style="backgroundImageStyle(item.image)"></div>
				</item>
			</lory>
			<div class="event-page-header-gradient" style="z-index: 1;">
				<div class="event-page-buttons-top-left event-header__buttons" style="z-index: 2;">
					<button
						style="width: 40px; text-align: left"
						type="button"
						class="btn-flat-icon--light"
						@click="goBack"
					>
						<img src="/static/images/navbar/logo-color.svg" height="38" alt="" />
					</button>
				</div>
				<div class="event-page-buttons-top-right event-header__buttons">
					<button
						type="button"
						class="btn-flat-icon--light ml-3"
						v-if="isHost"
						@click="openEditModal"
					>
						<v-icon large>fal fa-edit</v-icon>
					</button>
					<!-- <button
						type="button"
						class="btn-flat-icon--light ml-3"
						@click="favoriteLocation(location.slug)"
					>
						<v-icon large>{{ likedLocation }}</v-icon>
					</button> -->
				</div>
			</div>
		</div>
		<v-layout row wrap class="pa-3 event-page-body">
			<v-flex xs12 sm10 offset-sm1 md8 offset-md2 class="pa-2">
				<p class="mb-1" style="color: #444; text-align: left!iportant; font-size: 2.5em; font-weight: bold;">{{location.name}}</p>
				<p class="event-page-sub-heading-small mb-3">{{convertLocationType(location.location_type)}}{{locationShort}}</p>
				<p class="event-page-sub-heading">About the location</p>
				<p class="event-page-content" v-html="newlines(location.description)"></p>
				<google-map 
					class="mt-5"
					:mapcenter='mapcenter'
					:zoom='mapzoom'
					:radius="350">
				</google-map>
				<div class="mb-1 pb-1 mt-5" v-if="getLocationEvents.length > 0">
					<p class="mb-3" style="font-size: 1.1em; color: #666; font-weight: bold;">
						Upcoming events at this location
					</p>
					<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
						<div class="event-search__event-tile-flex" v-for="event in getLocationEvents" :key="event.pk">
							<event-list-item :event="event"></event-list-item>
						</div>
					</div>
				</div>
				<div class="mb-1 pb-1 mt-5" v-else>
					<p class="mb-3" style="font-size: 1.1em; color: #666; font-weight: bold;">
						Hmm... Looks like no WRKPRTYs are scheduled for this location at this time. Check out these other upcoming events nearby!
					</p>
					<div>
						<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
							<div class="event-search__event-tile-flex" v-for="event in getAllEvents.slice(0,3)" :key="event.pk">
								<event-list-item :event="event"></event-list-item>
							</div>
						</div>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GoogleMap from '~/components/GoogleMap'

import { fetchAllEvents, fetchLocationBySlug } from '~/store/api/event_location_api'
import { fetchUser } from '~/store/api/user'

import { replaceNewlines } from '~/store/util/util'

import EventListItem from '~/components/EventListItem.vue'

import { Item } from 'vue-lory'
import Lory from '~/components/LoryCarousel.vue'

import Vue from 'vue'

export default {
	data() {
		return {
			location: {},
			previousPage: null,
			locationPk: null,
			userAttending: false,
			photoDialog: false,
			mapzoom: 15
		}
	},
	created() {
		fetchAllEvents().then((response) => {
			this.setAllEvents(response.data)
		}).catch((error) => {
			console.error(error)
		})
		fetchLocationBySlug(this.$route.params.slug.replace('@', '')).then(response => {
			this.location = response.data
		}).catch(error => {
			console.log(error)
			this.$router.replace({ name: 'dashboard' })
			this.setSnackbarOpen(true)
			this.setSnackbarText('The location you\'re looking for does not exist!')
		})
	},
	methods: {
		...mapActions([
			'setAllEvents',
			'setModalOpen',
			'setEditEventContactFormEvent',
			'setSnackbarOpen',
			'setSnackbarText'
		]),
		backgroundImageStyle(image) {
			let style = {
				'background-image': 'url(' + image + ')',
				'background-position': 'center',
				'background-size': 'cover',
				'background-repeat': 'no-repeat',
				height: '100%'
			}
			return style
		},
		convertLocationType(val) {
			if (val === 'public') {
				return 'Public space - '
			} else if (val === 'house') {
				return 'Private home - '
			} else if (val === 'office') {
				return 'Office - '
			} else if (val === 'commercial') {
				return 'Commercial space - '
			} else {
				return ''
			}
		},
		newlines(value) {
			return replaceNewlines(value)
		},
		goBack() {
			this.$router.push('/')
		},
		openEditModal (val) {
			this.setModalOpen({ prop: 'editEventContactForm', value: val })
			this.setEditEventContactFormEvent(this.getEvent)
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (from.name !== 'host_add_location_submit') {
				vm.previousPage = from
			} else {
				vm.previousPage = {
					path: '/host/dashboard'
				}
			}
		})
	},
	watch: {
		currentTab() {
			// Call resizePreserveCenter() on all maps
			Vue.$gmapDefaultResizeBus.$emit('resize')
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getLocation',
			'getAllEvents',
		]),
		getImages() {
			let images = [].concat(this.location.additional_images)
			images = images.concat(this.location.primary_image)
			return images
		},
		getLocationEvents() {
			return this.getAllEvents.filter(e => {
				return e.location.pk === this.location.pk && e.approved
			})
		},
		isHost() {
			if (this.location) {
				return this.user.pk === this.location.owner || this.location.coowners.findIndex((owner) => owner === this.user.pk)
			}
		},
		locationShort() {
			let locationString = ''
			if (this.location.hasOwnProperty('address')) {
				let addressComponents = []
				if (this.isHost) {
					if (this.location.address.hasOwnProperty('street_number')) {
						if (this.location.address.hasOwnProperty('route')) {
							addressComponents.push(
								this.location.address.street_number +
									' ' +
									this.location.address.route
							)
						}
					}
				} else {
					if (this.location.address.hasOwnProperty('neighborhood')) {
						if (this.location.address.neighborhood !== '') {
							addressComponents.push(this.location.address.neighborhood)
						}
					}
				}
				if (this.location.address.hasOwnProperty('city')) {
					addressComponents.push(this.location.address.city)
				}
				if (this.location.address.hasOwnProperty('state')) {
					addressComponents.push(this.location.address.state)
				}
				if (this.location.address.hasOwnProperty('country')) {
					if (this.location.address.country !== 'United States') {
						addressComponents.push(this.location.address.country)
					}
				}
				for (var i = 0; i < addressComponents.length; i++) {
					locationString += addressComponents[i]
					if (i < addressComponents.length - 1) {
						locationString += ', '
					}
				}
			}
			return locationString
		},
		mapcenter() {
			return {
				lat: parseFloat(
					this.location.address.private_latitude ||
						this.location.address.public_latitude
				),
				lng: parseFloat(
					this.location.address.private_longitude ||
						this.location.address.public_longitude
				)
			}
		},
		likedLocation() {
			if (this.user.liked_locations.indexOf(this.location.pk) > -1) {
				return 'fas fa-heart'
			}
			return 'fal fa-heart'
		}
	},
	components: {
		GoogleMap,
		EventListItem,
		Lory,
		Item
	}
}
</script>

<style lang='scss' scoped>
.bg-min-height {
	height: 100%;
	min-height: 100vh;
}

.location-page-header {
	background-repeat: no-repeat;
	background-position: center center;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	position: absolute;
	left: 0;
	top: 0;

	width: 100vw;
	min-height: 50vh;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 0.99;
		z-index: 1;
		width: 100%;
		/*height: 150px;*/
		height: 101%;
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0.3) 0%,
			rgba(0, 0, 0, 0) 15%,
			rgba(255, 255, 255, 0) 70%,
			rgba(255, 255, 255, 1) 98%
		);
	}
}

.card-background-image {
	background: #000000;
}

.card-background-image > div:nth-child(1) {
	opacity: 0.5;
}

.tabs-bar {
	background: rgba(0, 0, 0, 0.5);
}

.flex-container {
	width: 100%;
	display: flex;
	flex-flow: row wrap;
}

.item-align-end {
	align-self: flex-end;

	display: flex;
	justify-content: flex-end;
}

.top-left-chip {
	position: absolute;
	z-index: 1;
	right: 0;
	top: 0;
	margin: 25px 10px;
}

.bottom-left-buttons {
	position: absolute;
	z-index: 1;
	right: 0;
	bottom: 0;
	margin: 0px 25px;
}

.event-search__event-tile-flex {
	width: 32%;
	height: 350px;
	margin-bottom: 60px;
}

/* lg */
@media screen and (max-width: 1920px) {
	.event-search__event-tile-flex {
		height: 300px;
	}
}

/* md */
@media screen and (max-width: 1280px) {
	.event-search__event-tile-flex {
		height: 250px;
		width: 48%;
	}
}

/* sm */
@media screen and (max-width: 960px) {
	.event-search__event-tile-flex {
		height: 250px;
	}
}

/* xs */
@media screen and (max-width: 599px) {
	.event-search__event-tile-flex {
		width: 100%;
		height: 300px;
	}
}
</style>
